import React from 'react';
import { useNavigate } from 'react-router-dom';
import { publisherData } from '../data/mockData';
import { Instagram, Twitter, Mail, Heart, BookOpen } from 'lucide-react';

export const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-12">
      <div className="container mx-auto px-6">
        {/* CTA Preview del Libro en Footer */}
        <div className="bg-gradient-to-r from-amber-600 to-amber-800 rounded-lg p-8 mb-12 text-center">
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-4">Empezá tu viaje interior hoy</h3>
          <p className="text-lg mb-6 opacity-90">Lee gratis las primeras 30 páginas de "Cábala para principiantes"</p>
          <button
            onClick={() => navigate('/reader/register')}
            className="inline-flex items-center space-x-2 bg-white text-amber-700 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg"
          >
            <BookOpen size={24} />
            <span>Leer Preview Gratis</span>
          </button>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-amber-600 to-amber-800 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">R</span>
              </div>
              <span className="text-2xl font-serif font-bold">{publisherData.name}</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              {publisherData.tagline}
            </p>
            <p className="text-gray-500 text-sm">
              {publisherData.location}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navegación</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('libro')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Libros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/reader/register')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Leer Preview Gratis
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('sobre-nosotros')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-400 hover:text-amber-400 transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Social & Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Conéctate</h4>
            <div className="flex space-x-4 mb-4">
              <a 
                href={publisherData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-amber-600 p-2 rounded-full transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href={publisherData.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-amber-600 p-2 rounded-full transition-colors duration-300"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
              <a 
                href={`mailto:${publisherData.email}`}
                className="bg-gray-800 hover:bg-amber-600 p-2 rounded-full transition-colors duration-300"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
            <a 
              href={`mailto:${publisherData.email}`}
              className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
            >
              {publisherData.email}
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} {publisherData.name}. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-sm flex items-center space-x-2">
              <span>Hecho con</span>
              <Heart className="text-amber-600" size={16} fill="currentColor" />
              <span>en Argentina</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};